import { message, Button } from 'antd';
import { cartApi, wishlistApi, setGuestCartId } from '../api/Api';
import store, {CART_COUNT_UPDATE, COMPARE_COUNT_UPDATE} from './store';

export const  addwishlist = async (productCode) => {
    try {
      const response = await wishlistApi.add(productCode);
      const resVal = response.data;
        if(resVal.status === 'success' || resVal.success === true){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
        return resVal;
    } catch (error) {
      console.error(error);
      return { status: 'error', message: 'Unable to add product to wishlist.' };
    }

} 

export const removewishlist = async (productCode) => {
    try {
      const response = await wishlistApi.remove(productCode);
      const resVal = response.data;
        if(resVal.status === 'success' || resVal.success === true){
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
        return resVal;
    } catch (error) {
      console.error(error);
      return { status: 'error', message: 'Unable to remove product from wishlist.' };
    }
}


export const  addtocart = async (productId, variantId, quantity = 1) => {
    try {
      const response = await cartApi.addItem({
          product_id: productId,
          product_sku_id: variantId,
          quantity,
          country_id: localStorage.getItem('country_id') || undefined,
      });
       let resVal=response.data;
        if(resVal.status==='success'){
            setGuestCartId(resVal.guest_cart_id);
            message.success({
                content: resVal.message || 'Product added to cart successfully.',
                className: 'notificationBox',
            });
            store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
        return resVal;
    } catch (error) {
      console.error(error);
      return { status: 'error', message: 'Unable to add product to cart.' };
    }

} 


export const removecart = async (cartItemId) => {
    try {
      const response = await cartApi.removeItem(cartItemId, {
          country_id: localStorage.getItem('country_id') || undefined,
      });
       let resVal=response.data;
        if(resVal.status==='success'){
            setGuestCartId(resVal.guest_cart_id);
            message.success({
                content: resVal.message,
                className: 'notificationBox',
            });
            store.dispatch({ type:CART_COUNT_UPDATE, value:resVal.cartCount});
        }else{
            message.error({
                content: resVal.message,
                className: 'notificationBox',
            });
        }
    } catch (error) {
      console.error(error);
    }
}


export const addtoCompare = (proTitle, proCode) => {
    if(!localStorage.getItem('natureway_compare_1')){
        localStorage.setItem('natureway_compare_1', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else if(!localStorage.getItem('natureway_compare_2')){
        localStorage.setItem('natureway_compare_2', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else if(!localStorage.getItem('natureway_compare_3')){
        localStorage.setItem('natureway_compare_3', proCode);
        message.success({
            content: proTitle+ " added to compare",
            className: 'notificationBox',
        });
    }else{
        message.error({
            content: "Only 3 products allowed to compare",
            className: 'notificationBox',
        });
    }

    /* compared vales count */
    store.dispatch({ type:COMPARE_COUNT_UPDATE, value:getCompareCount()});
}

export const removefromCompare = (proCode) => {
    if(localStorage.getItem('natureway_compare_1')==proCode){
        localStorage.removeItem('natureway_compare_1');
    }else if(localStorage.getItem('natureway_compare_2')==proCode){
        localStorage.removeItem('natureway_compare_2');
    }else if(localStorage.getItem('natureway_compare_3')==proCode){
        localStorage.removeItem('natureway_compare_3');
    }
    store.dispatch({ type:COMPARE_COUNT_UPDATE, value:getCompareCount()});
}

export const getCompare = () => {
    let FinalCompaValue=localStorage.getItem('natureway_compare_1')+','+localStorage.getItem('natureway_compare_2')+','+localStorage.getItem('natureway_compare_3');
    return FinalCompaValue;
}

export const getCompareCount = () => {

    // console.log(localStorage.getItem('natureway_compare_1'));
    // console.log(localStorage.getItem('natureway_compare_2'));
    // console.log(localStorage.getItem('natureway_compare_3'));
    let totCount=0;
    if(localStorage.getItem('natureway_compare_1')){
        totCount=totCount+1;
    }
    if(localStorage.getItem('natureway_compare_2')){
        totCount=totCount+1;
    }
    if(localStorage.getItem('natureway_compare_3')){
        totCount=totCount+1;
    }
    return totCount;
}
